import * as React from "react";

// Raised from 768 → 1024 so the sidebar collapses to a slide-in drawer on
// tablets too (Phase 1.9). Only the shadcn Sidebar primitive consumes this
// hook today; if the set of consumers grows, revisit whether 1024 is still
// the right threshold globally.
const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
